import { Check } from "lucide-react";

export default function FeatureList({ items }: { items: string[] }) {
  return (
    <section className="px-6 py-12 lg:px-8">
      <ul className="mx-auto max-w-3xl space-y-4">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-3 rounded-xl border border-border bg-card p-4">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/15">
              <Check className="h-4 w-4 text-primary" />
            </span>
            <span className="text-base leading-7 text-foreground">{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
